export const getBaseEmployersQuery = () => ['employers']
export const getBasePaySchedulesQuery = () => ['paySchedules']
